// src/api/clients.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب كل العملاء
 */
export const fetchClients = () =>
  axiosInstance.get('/clients/');

/**
 * إنشاء عميل جديد
 * @param {{ name: string, phone?: string }} payload
 */
export const createClient = (payload) =>
  axiosInstance.post('/clients/', payload);

/**
 * تحديث بيانات عميل
 * @param {number} id
 * @param {{ name?: string, phone?: string }} payload
 */
export const updateClient = (id, payload) =>
  axiosInstance.patch(`/clients/${id}/`, payload);


/**
 * تغيير كلمة مرور حساب العميل
 * @param {number} id
 * @param {{ new_password: string }} payload
 */
export const resetClientPassword = (id, payload) =>
  axiosInstance.patch(`/clients/${id}/reset-password/`, payload);